import React, { useState, useEffect, useMemo } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";
import { TextField, Box, Button } from "@mui/material";
import { NumericFormat } from "react-number-format";

import CardSection from "../../../components/CardSection/CardSection";
import MySelect from "../../../components/CardSection/MySelect";
import {
  getKinshasaDateTime,
  getKinshasaDate,
  getKinshasaTimeHMS,
} from "../../../utils/getKinshasaDateTime";
import { db, auth } from "../../../config/firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { selectActiveUid } from "../../Auth/authSlice";
const toInt = (v) => parseInt(String(v).replace(/[^\d-]/g, ""), 10);

const Retrait = () => {
  const [retraitMap, setRetraitMap] = useState({});
  const activeUid = useSelector(selectActiveUid);
  const [comment, setComment] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [amount, setAmount] = useState("");
  const [cardOpen, setCardOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let canceled = false;
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        if (!canceled) setRetraitMap({});
        return;
      }
      try {
        // 1) Lire le champ ville du document utilisateur
        const userRef = doc(db, "users", activeUid);
        const userSnap = await getDoc(userRef);

        let villeValue = null;
        if (userSnap.exists()) {
          villeValue = userSnap.data().ville; // ex: "KIN"
        }

        // 2) Choix du document config selon la ville
        let configDocName = "";
        if (villeValue === "KIN") configDocName = "retrait_kin";
        if (villeValue === "KGA") configDocName = "retrait_kga";
        if (!configDocName) {
          console.warn("Ville value is missing or invalid:", villeValue);
          if (!canceled) setRetraitMap({});
          return;
        }
        const configRef = doc(db, "config", configDocName);
        const configSnap = await getDoc(configRef);

        if (configSnap.exists()) {
          if (!canceled) setRetraitMap(configSnap.data() || {});
          return;
        }
        if (!canceled) setRetraitMap({});
      } catch (e) {
        console.error("load pump_items failed:", e);
      }
    });
    return () => {
      canceled = true;
      unsub();
    };
  }, [activeUid]);

  // Map -> options { value: ordreNumérique, label: code }, triées par value
  const listRetrait = useMemo(
    () =>
      Object.entries(retraitMap)
        .map(([code, order]) => ({ value: toInt(order), label: code }))
        .sort((a, b) => a.value - b.value),
    [retraitMap]
  );

  const onClick = async (e) => {
    e.stopPropagation();
    if (!selectedProduct || !amount) return;
    setLoading(true);
    const date = getKinshasaDate();
    const timeKey = getKinshasaTimeHMS();
    const dateTime = getKinshasaDateTime();
    try {
      const docRef = doc(db, "users", activeUid, "data", date);
      const fieldKey = `RETRAIT_PROD_${timeKey}`;
      const payload = {
        [fieldKey]: {
          item: selectedProduct,
          value: amount,
          type: "RETRAIT",
          date: dateTime,
          comment: comment,
        },
      };
      await setDoc(docRef, payload, { merge: true });
      setComment("");
      setSelectedProduct("");
      setAmount("");
      setCardOpen(false);
    } catch (e) {
      console.error("Error adding document: ", e);
    }
    setLoading(false);
  };

  return loading ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 32,
      }}
    >
      <CircularProgress color="primary" size={48} />
      <div style={{ marginTop: 16, fontSize: 18 }}>Chargement...</div>
    </div>
  ) : (
    <CardSection
      title="RETRAIT PRODUIT"
      showDefaultControls={false}
      open={cardOpen}
      setOpen={setCardOpen}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        <TextField
          label="Autorisé par / Commentaire"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          size="small"
          variant="outlined"
          fullWidth
        />

        <MySelect
          listItem={listRetrait}
          value={selectedProduct}
          onChange={(e) => setSelectedProduct(e.target.value)}
        />

        <NumericFormat
          customInput={TextField}
          label="Qte(L)"
          value={amount}
          onValueChange={(values) => setAmount(values.value)}
          size="small"
          variant="outlined"
          fullWidth
          allowNegative={false}
          isAllowed={({ floatValue }) =>
            floatValue === undefined || floatValue >= 0
          }
          thousandSeparator=" "
          decimalSeparator=","
          decimalScale={2}
          fixedDecimalScale
          format="### ### ###,##"
          mask="_"
        />

        <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
          <Button
            variant="contained"
            color="success"
            onClick={onClick}
            disabled={!comment || !selectedProduct || !amount}
          >
            ENVOYER
          </Button>
        </Box>
      </Box>
    </CardSection>
  );
};

export default Retrait;
